module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "head"
  }, [_c('div', {
    staticClass: "super-title"
  }, [_vm._v("已消费美团券明细")]), _vm._v(" "), _c('router-link', {
    staticClass: "head-link",
    attrs: {
      "to": {
        name: 'ticketsingleProgram'
      }
    }
  }, [_vm._v("返回“单个项目消费明细”")])], 1), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-text"
  }, [_c('a', {
    attrs: {
      "href": _vm.programNameUrl + _vm.dealId + '.html',
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.dealName))])])])]), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_vm._v("门票已验证但却找不到？请确认是否选错了项目，或在\n        "), _c('router-link', {
    attrs: {
      "to": {
        name: 'ticketallProgram'
      }
    }
  }, [_vm._v("所有项目消费明细")])], 1), _vm._v(" "), _c('div', {
    staticClass: "common-tip-blk"
  }, [_c('span', [_c('i', {
    staticClass: "F-glob F-glob-status-info"
  }), _vm._v(" "), _c('strong', [_vm._v("合计")]), _vm._v(_vm._s(_vm.useTimeStart) + "累计验证\n            "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.totalVerifyNum || 0))]), _vm._v("张,撤销\n            "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.totalRevocationNum || 0))]), _vm._v("张,明细如下:\n        ")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right"
  }, [_c('a', {
    attrs: {
      "href": _vm.apiHost + _vm.generateUrl,
      "target": "_blank"
    }
  }, [_vm._v("下载明细记录")])])]), _vm._v(" "), _c('div', {
    staticClass: "tablewrapper"
  }, [_c('table', {
    staticClass: "table table-hover table-bordered"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.detailList), function(item, index) {
    return _c('tr', [_c('td', [_c('a', {
      attrs: {
        "href": _vm.otpHost + _vm.detailUrl + item.orderId
      }
    }, [_vm._v(_vm._s(item.orderId))])]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(_vm._f("formdate")(item.operationTime)) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(item.operationType == 1 ? '验证' : '撤销') + "\n                    ")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(item.voucherCode))])]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(item.quantity) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.operatorName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.source))]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(item.sellPrice) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(item.totalPrice) + "\n                    ")])])
  }))]), _vm._v(" "), (_vm.noData) ? _c('p', {
    staticClass: "nodata"
  }, [_vm._v("未查询到匹配内容")]) : _vm._e(), _vm._v(" "), _c('v-pagination', {
    staticClass: "pull-right",
    attrs: {
      "current": _vm.current,
      "total": _vm.totalPage,
      "size": 'md',
      "first": false,
      "last": false
    },
    on: {
      "current-change": function($event) {
        _vm.currentChangeFunc($event)
      }
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-item  control-label"
  }, [_c('strong', [_vm._v("项目名称：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("订单号")]), _vm._v(" "), _c('th', [_vm._v("操作时间")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("电子票密码")]), _vm._v(" "), _c('th', [_vm._v("操作数量")]), _vm._v(" "), _c('th', [_vm._v("操作人")]), _vm._v(" "), _c('th', [_vm._v("来源")]), _vm._v(" "), _c('th', [_vm._v("消费者购买价")]), _vm._v(" "), _c('th', [_vm._v("总价")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7615824a","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ticket/verify/history/pages/detailConsumption.vue
// module id = 817
// module chunks = 0